import React, { lazy, useCallback } from 'react';
import ClickAwayContainer from 'editor/components/ClickAwayContainer';
import { Suspense } from 'react';

const ResultPageFroalaEditorContainer = lazy(() =>
    import('editor/components/Froala/FroalaContainer')
);

const ResultPageFroalaClientContainer = lazy(() =>
    import('client/components/Froala/FroalaContainer')
);

/**
 * @param {Object} props
 * @param {Boolean} props.isEditor - 是否為編輯模式
 * @param {Boolean} props.disabled - 是否禁用編輯
 * @param {String} props.content - 編輯器內容
 * @param {Function} props.onChange - 內容變更回調
 * @param {String} props.sectionId - 區塊 ID
 * @param {Boolean} props.isFocused - 是否被選中
 * @param {Function} props.onClickAway - 點擊外部回調
 * @param {Function} props.onClick - 點擊回調
 * @param {React.ReactNode} props.iconSlot - 圖標插槽
 * @returns {JSX.Element}
 */
export default function ResultPageFroalaView({
    isEditor,
    disabled,
    content,
    onChange,
    sectionId,
    isFocused,
    onClickAway,
    onClick,
    iconSlot
}) {
    const FroalaContainer = useCallback(
        props => {
            return isEditor ? (
                <ResultPageFroalaEditorContainer {...props} />
            ) : (
                <ResultPageFroalaClientContainer {...props} />
            );
        },
        [isEditor]
    );

    return (
        <Suspense>
            <ClickAwayContainer
                isEditor={isEditor && !disabled}
                showHover={true}
                isFocused={isFocused}
                sectionId={sectionId}
                onClickAway={onClickAway}
                onClick={onClick}
                iconSlot={iconSlot}
            >
                <FroalaContainer
                    disabled={disabled}
                    content={content}
                    onChange={onChange}
                    elementId={`result-page-${sectionId}`}
                />
            </ClickAwayContainer>
        </Suspense>
    );
}
